// Action Types
export const FETCH_INSIGHTS = 'aiInsights/fetchInsights';
export const FETCH_INSIGHTS_SUCCESS = 'aiInsights/fetchInsightsSuccess';
export const FETCH_INSIGHTS_ERROR = 'aiInsights/fetchInsightsError';
export const CLEAR_INSIGHTS = 'aiInsights/clearInsights';

// Processing stage action types
export const UPDATE_PROCESSING_STAGE = 'aiInsights/updateProcessingStage';

// Action Creators
export const fetchInsights = (eventId, questionType = 'default', data = null) => ({
  type: FETCH_INSIGHTS,
  payload: { eventId, questionType, data }
});

export const fetchInsightsSuccess = (eventId, insights) => ({
  type: FETCH_INSIGHTS_SUCCESS,
  payload: { eventId, insights }
});

export const fetchInsightsError = (eventId, error) => ({
  type: FETCH_INSIGHTS_ERROR,
  payload: { eventId, error }
});

export const clearInsights = (eventId) => ({
  type: CLEAR_INSIGHTS,
  payload: { eventId }
});

// Action creator for updating the current processing stage
export const updateProcessingStage = (eventId, stage) => ({
  type: UPDATE_PROCESSING_STAGE,
  payload: { eventId, stage }
});